import builder from '../builder';
import UploadButtonIcon from '../../streamline-icons/bold/upload-bottom.svg';

export default builder('Upload', UploadButtonIcon);
